import { useClassContext } from "../../../../context/ClassContext";
import useDates from "../../../../hooks/useDates";
import "./Header.scss";
import React from "react";

const Header = () => {
  const { clase, setAddUserModal, setShowChangeTeacherModal } =
    useClassContext();
  const { fullFormatDate, getHourInHermosillo } = useDates();

  const handleShowModal = (type: "user" | "teacher") => {
    if (type === "user") {
      setAddUserModal(true);
    } else if (type === "teacher") {
      setShowChangeTeacherModal(true);
    }
  };

  if (!clase) return <></>;

  return (
    <div className="clase-page-header-main-container d-flex flex-column gap-2">
      <div className="row align-items-center justify-content-between mb-4">
        <h2 className="m-0 fs-36 fw-bolder">
          {clase.custom_name || clase.lesson.name}
        </h2>
        <div className="row gap-2">
          <button
            className="btn btn-primary px-4 fs-12"
            onClick={() => handleShowModal("user")}
            disabled={clase.status === "CLOSED"}
          >
            Agregar alumno
          </button>
          <button
            className="btn btn-primary px-4 fs-12"
            onClick={() => handleShowModal("teacher")}
          >
            Cambiar maestro
          </button>
        </div>
      </div>
      <h3 className="fs-16">
        <b>Horario:</b> {getHourInHermosillo(clase.startDate)}
        {" - "}
        {getHourInHermosillo(clase.endDate)}
      </h3>
      <h3 className="fs-16">{clase?.location.name}</h3>
      <h4 className="fs-18">
        <b>Maestra:</b> {clase?.employee.name} {clase?.employee.lastname}
      </h4>
      <h4 className="text-end fw-bold mt-4">
        {fullFormatDate(clase!.startDate)}
      </h4>
    </div>
  );
};

export default Header;
